/* Height animation for the benefits and Our Story disclosures. Reduced motion
   settles the requested state directly; functionality never waits for motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 900px)');
  var active = new Set();
  var benefits = new Map();

  function setup(trigger, panel, details) {
    if (!panel || trigger.dataset.aobAccordion === 'on') return;
    trigger.dataset.aobAccordion = 'on';
    var expanded = details ? details.open : desktop.matches;
    var animation = null;

    function cancel() {
      if (!animation) return;
      animation.onfinish = null;
      animation.oncancel = null;
      animation.cancel();
      animation = null;
    }

    function settle() {
      cancel();
      active.delete(settle);
      panel.style.overflow = '';
      panel.inert = !expanded;
      trigger.setAttribute('aria-expanded', String(expanded));
      if (details) details.open = expanded;
      else panel.hidden = !expanded;
    }

    function setOpen(open, animate) {
      // Capture the painted height before cancelling so a second tap reverses
      // from the current position instead of jumping to either endpoint.
      var from = expanded || animation ? panel.getBoundingClientRect().height : 0;
      cancel();
      expanded = open;
      trigger.setAttribute('aria-expanded', String(open));
      if (!open && panel.contains(document.activeElement)) trigger.focus();
      panel.inert = !open;

      // Keep the content in flow until a closing animation has finished.
      if (details) details.open = true;
      else panel.hidden = false;
      var to = open ? panel.getBoundingClientRect().height : 0;

      if (!animate || reduced.matches || !panel.animate || Math.abs(from - to) < 1) {
        settle();
        return;
      }

      panel.style.overflow = 'hidden';
      animation = panel.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: 260, easing: 'cubic-bezier(.2, 0, 0, 1)', fill: 'both' }
      );
      active.add(settle);
      animation.onfinish = settle;
      animation.oncancel = settle;
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      setOpen(!expanded, true);
    });

    if (details) {
      // Preserve native/programmatic changes to <details> as well as clicks.
      details.addEventListener('toggle', function () {
        if (!animation && details.open !== expanded) setOpen(details.open, false);
      });
    } else {
      benefits.set(trigger, setOpen);
    }
    settle();
  }

  function scan() {
    document.querySelectorAll('[data-aob-pt]').forEach(function (trigger) {
      setup(trigger, trigger.closest('.aob-box__item').querySelector('.aob-box__panel'));
    });
    document.querySelectorAll('.aob-val__row').forEach(function (details) {
      setup(details.querySelector('summary'), details.querySelector('.aob-val__content'), details);
    });
  }

  function settleActive() {
    active.forEach(function (settle) { settle(); });
  }

  function listen(query, handler) {
    if (query.addEventListener) query.addEventListener('change', handler);
    else query.addListener(handler);
  }

  listen(reduced, function () {
    if (reduced.matches) settleActive();
  });
  listen(desktop, function () {
    benefits.forEach(function (setOpen, trigger) {
      if (trigger.isConnected) setOpen(desktop.matches, false);
      else benefits.delete(trigger);
    });
  });
  // Release measured heights before text reflows at a new viewport width.
  window.addEventListener('resize', settleActive, { passive: true });
  document.addEventListener('shopify:section:unload', function (event) {
    settleActive();
    benefits.forEach(function (_, trigger) {
      if (event.target.contains(trigger)) benefits.delete(trigger);
    });
  });
  document.addEventListener('shopify:section:load', scan);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
